import api from '@Api/Api'
import { BaseApi } from '@Features/Base/BaseApi/BaseApi'

const SettingsApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		// Addressed by server-minted uuid. `device_id` was chosen by the browser,
		// so it was never a safe thing to look a row up by.
		logoutDevice: builder.mutation<ApiResponse<Device>, DeviceId>({
			query: payload => ({
				url: 'devices/logout/single',
				method: 'POST',
				body: {
					uuid: payload.uuid,
				},
			}),
		}),
	}),
})

export const { useLogoutDeviceMutation } = SettingsApi

export default class TrustedDevicesApi {
	public static getAllDevices() {
		return api.get<ApiResponse<Device[]>>('/devices/fetch')
	}
	public static logoutAllDevices() {
		return api.post<ApiResponse<Device[]>>('/devices/logout/all')
	}
}
